import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { useLang } from "@/context/LanguageContext";
import SEO from "@/components/SEO";
import PageHeader from "@/components/PageHeader";

/* ARCADE — paused. Same visual system as the rest of the site: black, off-white,
   one acid accent. The "insert coin" is a mono label, not a neon sign. */
export default function Arcade() {
    const { lang } = useLang();
    const en = lang === "en";

    return (
        <div data-testid="arcade-page" className="bg-abnormal-ink min-h-[70vh]">
            <SEO
                title={en ? "Arcade · Coming Soon" : "Arcade · In arrivo"}
                description={en
                    ? "Abnormal Arcade is loading. Riding challenges and Argentario Stages quests coming soon."
                    : "Abnormal Arcade in caricamento. Sfide reali sui trail e quest Argentario Stages presto disponibili."}
                path="/arcade"
            />
            <PageHeader
                label="ABNORMAL · ARCADE"
                title="Coming"
                accent="soon"
                tagline={["Argentario Stages", en ? "Real riding quests" : "Sfide reali sui trail", "Hall of Fame"]}
                sub={en
                    ? "Riding challenges verified on Strava, four levels, real rewards. We'd rather ship it right than ship it now."
                    : "Sfide sui trail verificate via Strava, quattro livelli, premi veri. Preferiamo farlo bene che farlo subito."}
            />

            <div className="max-w-[1400px] mx-auto px-5 md:px-10 py-12 md:py-16 grid md:grid-cols-12 gap-8">
                <div className="md:col-span-7 border border-white/15 p-6 md:p-8">
                    <p data-testid="arcade-insert-coin" className="label-mono text-abnormal-acid">★ INSERT COIN ★ CREDIT 00 ★</p>
                    <div data-testid="arcade-loader" className="mt-6 h-2 border border-abnormal-paper/40 relative overflow-hidden">
                        <div className="absolute inset-y-0 left-0 bg-abnormal-acid arcade-loader-bar" />
                    </div>
                    <p className="mt-2 label-mono text-abnormal-paperDim/60">LOADING ARGENTARIO STAGES…</p>
                    <ul className="mt-8 grid grid-cols-2 sm:grid-cols-4 gap-3">
                        {["Rookie", "Local", "Hard Hitter", "Legend"].map((lvl, i) => (
                            <li key={lvl} className="border border-white/10 p-3">
                                <p className="label-mono text-abnormal-acid">LVL 0{i + 1}</p>
                                <p className="font-display uppercase text-2xl leading-none mt-1 text-abnormal-paper">{lvl}</p>
                            </li>
                        ))}
                    </ul>
                </div>
                <div className="md:col-span-5 flex flex-col justify-between gap-6">
                    <p className="font-display uppercase text-3xl md:text-5xl leading-[0.9] tracking-tight text-abnormal-paper">
                        {en ? "In the meantime: " : "Nel frattempo: "}
                        <span className="text-abnormal-acid">{en ? "go ride." : "vai a pedalare."}</span>
                    </p>
                    <Link to="/trail" data-testid="arcade-go-trails" className="btn-primary self-start">
                        {en ? "Trail report" : "Trail report"} <ArrowRight size={14} />
                    </Link>
                </div>
            </div>
            <style>{`
                @keyframes arcade-loader { 0% { width: 8%; } 50% { width: 78%; } 100% { width: 32%; } }
                .arcade-loader-bar { animation: arcade-loader 2.4s ease-in-out infinite; }
                @media (prefers-reduced-motion: reduce) { .arcade-loader-bar { animation: none; width: 40%; } }
            `}</style>
        </div>
    );
}
